import React, { useEffect, useMemo, useState } from "react";
import "./layout.css";
import Sidebar from "../sidebar/Sidebar";
import TopNav from "../topnav/TopNav";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import ThemeAction from "../../redux/actions/ThemeAction";
import Auth from "../../Auth";
import Login from "../../pages/Login";
import Dashboard from "../../pages/Dashboard";
import AddAd from "../../pages/AddPost";
import Register from "../../pages/Register";
import VerifyCode from "../../pages/VerifyCode";
import Customers from "../../pages/Customers";
import About from "../../pages/About";
import Home from "../../pages/Home";
import AddUrlAd from "../../pages/AddUrlAd";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Advertising from "../../pages/Advertising";
import Tarif from "../../pages/Tarif";
import Profile from "../../pages/Profile";
import AddTariff from "../../pages/AddTariff";
import NewPassword from "../../pages/NewPassword";
import MessagesController from "../../pages/Messages";
import ChatGroup from "../../pages/ChatGroup";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Confirmation from "../../pages/Moderation";
import CPost from "../CPost";
import CURL from "../CURL";
import SearchHIstory from "../../pages/SearchHIstory";
import ControlCat from "../../pages/ControlCat";
import { useBreakpoints } from "react-breakpoints-hook";

const Layout = () => {
  // menu admin
  const [menu, setMenu] = useState([
    {
      path: "/",
      exact: true,
      component: Home,
    },
    {
      path: "/profile",
      exact: false,
      component: Profile,
    },
    {
      path: "/tariffs",
      exact: false,
      component: Tarif,
    },

    {
      path: "/about",
      exact: false,
      component: About,
    },
  ]);

  const dispatch = useDispatch();
  // reducer
  const role = useSelector((state) => state.reducer.user?.roles, shallowEqual);
  useEffect(() => {
    const themeClass = localStorage.getItem("themeMode", "theme-mode-light");
    const colorClass = localStorage.getItem("colorMode", "theme-mode-light");
    if (role) {
      if (role.indexOf("ROLE_SUPPER_ADMIN") > -1) {
        setMenu([
          {
            path: "/dashboard",
            exact: true,
            component: Dashboard,
          },
          {
            path: "/message",
            exact: true,
            component: MessagesController,
          },
          {
            path: "/category",
            exact: false,
            component: ControlCat,
          },
          {
            path: "/confirm",
            exact: true,
            component: Confirmation,
          },

          {
            path: "/sendpost",
            exact: true,
            component: CPost,
          },
          {
            path: "/sendurl",
            exact: true,
            component: CURL,
          },
          {
            path: "/url_ad",
            exact: false,
            component: AddUrlAd,
          },
          {
            path: "/",
            exact: true,
            component: Home,
          },
          {
            path: "/profile",
            exact: false,
            component: Profile,
          },
          {
            path: "/tariffs",
            exact: false,
            component: Tarif,
          },

          {
            path: "/about",
            exact: false,
            component: About,
          },
          {
            path: "/post_ad",
            exact: false,
            component: AddAd,
          },
          {
            path: "/advertising",
            exact: true,
            component: Advertising,
          },
          {
            path: "/tariff_control",
            exact: false,
            component: AddTariff,
          },
          {
            path: "/group",
            exact: false,
            component: ChatGroup,
          },
          {
            path: "/users",
            exact: false,
            component: Customers,
          },
          {
            path: "/search-history",
            exact: false,
            component: SearchHIstory,
          },
          {
            path: "/messages",
            exact: false,
            component: MessagesController,
          },
        ]);
      } else if (role.indexOf("ROLE_ADMIN") > -1) {
        setMenu([
          {
            path: "/",
            exact: true,
            component: Home,
          },
          {
            path: "/profile",
            exact: false,
            component: Profile,
          },
          {
            path: "/tariffs",
            exact: false,
            component: Tarif,
          },

          {
            path: "/about",
            exact: false,
            component: About,
          },
          {
            path: "/url_ad",
            exact: false,
            component: AddUrlAd,
          },
          {
            path: "/post_ad",
            exact: false,
            component: AddAd,
          },
          {
            path: "/advertising",
            exact: true,
            component: Advertising,
          },
          {
            path: "/tariff_control",
            exact: false,
            component: AddTariff,
          },
        ]);
      } else if (role?.indexOf("ROLE_MODERATOR") > -1) {
        setMenu([
          {
            path: "/advertising",
            exact: true,
            component: Advertising,
          },
          {
            path: "/",
            exact: true,
            component: Confirmation,
          },

          {
            path: "/sendpost",
            exact: true,
            component: CPost,
          },
          {
            path: "/sendurl",
            exact: true,
            component: CURL,
          },
          {
            path: "/profile",
            exact: false,
            component: Profile,
          },
          {
            path: "/tariffs",
            exact: false,
            component: Tarif,
          },
          {
            path: "/tariff_control",
            exact: false,
            component: AddTariff,
          },
          {
            path: "/about",
            exact: false,
            component: About,
          },
          {
            path: "/dashboard",
            exact: true,
            component: Dashboard,
          },
          {
            path: "/url_ad",
            exact: false,
            component: AddUrlAd,
          },
          {
            path: "/post_ad",
            exact: false,
            component: AddAd,
          },
        ]);
      }
    }
    dispatch(ThemeAction.setMode(themeClass));
    dispatch(ThemeAction.setColor(colorClass));
  }, [role, dispatch]);

  const theme = useMemo(
    () =>
      createTheme({
        components: {
          // Name of the component
          MuiSkeleton: {
            styleOverrides: {
              // Name of the slot
              root: {
                // Some CSS
                borderRadius: "0.25rem",
              },
            },
          },
        },
        palette: {
          mode: "dark",
          primary: {
            main: "#2993ff",
          },
          text: {
            main: "#fff",
            disabled: "#ffffff76",
          },
          background: {
            paper: "#082F57",
          },
        },
      }),
    []
  );

  let { xs, sm, md, lg } = useBreakpoints({
    xs: { min: 0, max: 360 },
    sm: { min: 361, max: 960 },
    md: { min: 961, max: 1400 },
    lg: { min: 1401, max: null },
  });

  const [open] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          {Auth.isAuthenticated() ? (
            <Route
              render={(props) => (
                <div className={`layout theme-mode-dark `}>
                  {lg && <Sidebar {...props} />}

                  <div className="layout__content">
                    <TopNav
                      breakpoint={md || sm || xs ? true : false}
                      sidebar={<Sidebar />}
                      open={open}
                    />

                    <div className="layout__content-main">
                      {menu.map((v, i) => (
                        <Route
                          path={v.path}
                          exact={v.exact}
                          component={v.component}
                          key={i}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            />
          ) : (
            <Switch>
              <Route path="/register" component={Register} />
              <Route path="/verify" component={VerifyCode} />
              <Route path="/about" component={About} />
              <Route path="/newPassword" component={NewPassword} />
              <Route path="/" exact component={Login} />
              <Redirect to="/" />
            </Switch>
          )}
          {/* <Route path="/login" component={Login}/> */}
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default Layout;
